import { useId, useState } from 'react';
import { CATEGORIES_ETAPE, CATEGORIES_SUGGESTION } from '../lib/trips.js';

/**
 * Formulaire d'une étape ou d'une suggestion, utilisé aussi bien pour l'ajout
 * que pour la modification. Les champs diffèrent selon le mode : une
 * suggestion n'a pas d'horaire, puisque les dates ne sont pas fixées.
 */
export function ElementForm({ element, mode, libelleAction, onSubmit, onCancel }) {
  const identifiant = useId();
  const suggestions = mode === 'suggestions_only';
  const categories = suggestions ? CATEGORIES_SUGGESTION : CATEGORIES_ETAPE;

  const [champs, setChamps] = useState({
    time: element?.time ?? '',
    title: element?.title ?? '',
    description: element?.description ?? '',
    category: element?.category ?? (suggestions ? 'visite' : 'visite'),
  });
  const [erreur, setErreur] = useState(null);
  const [envoi, setEnvoi] = useState(false);

  const modifier = (champ) => (evenement) =>
    setChamps((precedent) => ({ ...precedent, [champ]: evenement.target.value }));

  async function soumettre(evenement) {
    evenement.preventDefault();
    setErreur(null);
    setEnvoi(true);

    try {
      await onSubmit({
        title: champs.title.trim(),
        description: champs.description.trim() || null,
        category: champs.category,
        ...(suggestions ? {} : { time: champs.time || null }),
      });
    } catch (echec) {
      setErreur(echec.message);
      setEnvoi(false);
    }
  }

  return (
    <form className="element-form" onSubmit={soumettre} noValidate>
      {!suggestions && (
        <div className="champ">
          <label htmlFor={`${identifiant}-heure`}>Horaire</label>
          <input
            id={`${identifiant}-heure`}
            type="time"
            value={champs.time}
            onChange={modifier('time')}
          />
          <p className="aide">Laissez vide pour une étape sans heure précise.</p>
        </div>
      )}

      <div className="champ">
        <label htmlFor={`${identifiant}-titre`}>Titre</label>
        <input
          id={`${identifiant}-titre`}
          type="text"
          value={champs.title}
          onChange={modifier('title')}
          required
        />
      </div>

      <div className="champ">
        <label htmlFor={`${identifiant}-categorie`}>Catégorie</label>
        <select
          id={`${identifiant}-categorie`}
          value={champs.category}
          onChange={modifier('category')}
        >
          {categories.map(([valeur, libelle]) => (
            <option key={valeur} value={valeur}>
              {libelle}
            </option>
          ))}
        </select>
      </div>

      <div className="champ">
        <label htmlFor={`${identifiant}-description`}>Description</label>
        <textarea
          id={`${identifiant}-description`}
          rows="3"
          value={champs.description}
          onChange={modifier('description')}
        />
      </div>

      {erreur && (
        <p className="erreur" role="alert">
          {erreur}
        </p>
      )}

      <div className="actions">
        <button className="bouton" type="submit" disabled={envoi}>
          {envoi ? 'Enregistrement…' : libelleAction}
        </button>
        <button className="bouton bouton--discret" type="button" onClick={onCancel}>
          Annuler
        </button>
      </div>
    </form>
  );
}
